import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const leadUpdatedAtFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'updated_at_before',
    after: 'updated_at_after',
  }),
  color: FILTER_COLOR.teal,
  withNoneOption: false,
});
